import axios from '@/axiosr8'
const path = 'possonline/alarms/sections/'

class SectionAlarmsProvider {
  async getAlarmSettings (token, objectId) {
    const result = await axios.get(path + `${btoa(objectId)}/alarmsettings`, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async updateAlarmSettings (token, objectId, alarmsettings) {
    const result = await axios.put(path + `${btoa(objectId)}/alarmsettings/${alarmsettings.id}`, alarmsettings, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async saveAlarmSettings (token, objectId, alarmsettings) {
    const result = await axios.post(path + `${btoa(objectId)}/alarmsettings`, alarmsettings, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getAlarmResults (token, objectId, dtFrom, dtTo) {
    const result = await axios.get(path + `${btoa(objectId)}/results?dtFrom=${dtFrom}&dtTo=${dtTo}`, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }
  async getAlarmResultsByAssets (tokens, limit) {
    const result = await axios.post(path + 'all/results?limit=' + limit, tokens)
    return result.data
  }
  async getShuntStates (token, objectId, dtFrom, dtTo) {
    let result = await axios.get(path + `${btoa(objectId)}/shuntstateanalysis?dtFrom=${dtFrom}&dtTo=${dtTo}`, {
      headers: {
        'asset-token': token
      }})
    if (result != null) {
      return result.data
    }
    return null
  }
}

export default new SectionAlarmsProvider()



// WEBPACK FOOTER //
// ./src/providers/SectionAlarmsProvider.js